import React, { useState } from 'react';
import { ClipboardIcon, CheckIcon } from '@heroicons/react/24/outline';

interface CodeBlockProps {
  code: string;
  language?: string;
}

export const CodeBlock: React.FC<CodeBlockProps> = ({ code, language }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (error) {
      console.error('Failed to copy code', error);
    }
  };

  return (
    <div className="bg-gray-900 rounded-xl border border-gray-800 overflow-hidden">
      <div className="flex items-center justify-between px-4 py-2 border-b border-gray-800">
        <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wide text-gray-400">
          <span>Code</span>
          {language && <span className="text-gray-500">· {language}</span>}
        </div>
        <button
          type="button"
          onClick={handleCopy}
          className="flex items-center gap-2 text-xs font-semibold text-gray-200 hover:text-white"
        >
          {copied ? (
            <>
              <CheckIcon className="h-4 w-4" />
              Copied ✓
            </>
          ) : (
            <>
              <ClipboardIcon className="h-4 w-4" />
              Copy
            </>
          )}
        </button>
      </div>
      <pre className="overflow-x-auto p-4 text-sm text-gray-100 leading-relaxed">
        <code className="whitespace-pre">{code}</code>
      </pre>
    </div>
  );
};
